<template>
  <div class="page">
    <portal to="layout-nav-title">
      <el-button
        class="nav-layout-header-btn-back"
        type="text"
        icon="el-icon-back"
        @click="$router.go(-1)"
      >
      {{ $t('bean.actionNavBack') }}
      </el-button>
      <span v-if="COMMENT_TYPE === 'YouthCamp'">青训营心得</span>
      <template v-else>
        {{ COMMENT_TYPE === 'BookClub' ? '心得' : '评论' }} - <bean-link :to="{ name: `${resourceName}.show`, params: { id: $route.params.id } }">{{ post.title }}</bean-link>
      </template>
    </portal>
    <div class="box-filter">
      <bean-filter :columns="columns" v-model="filter" @filter="handleFilter" @reset="handleReset" />
    </div>
    <div class="page-content">
      <div class="empty" v-if="pageInited && comments.length <= 0">暂无数据</div>
      <div class="comment-first-level" v-for="(item, index) in comments" :key="item.id">
        <Comment :value="item" @change="handleChange(index, $event)" />
      </div>
    </div>
    <div class="box-pagination">
      <bean-pagination v-bind="pagination" @submit="handleFetch" />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import Comment from '@/components/comment.vue';
import _ from 'lodash';
import pluralize from 'pluralize';

@Component({
  components: {
    Comment,
  },
})
export default class Comments extends Vue {
  @Prop(String) commentType;

  filter = {};
  comments = [];
  pagination = [];
  pageInited = false;
  post = {};

  columns = [
    {
      prop: 'content_cont',
      label: '内容',
      renderCell: {
        component: 'input',
      },
    }
  ]

  get COMMENT_TYPE() {
    return this.commentType || this.$route.params.commentType;
  }

  get resourceName() {
    return pluralize(_.snakeCase(this.COMMENT_TYPE));
  }

  mounted() {
    this.filter = JSON.parse(JSON.stringify(this.$route.query));
    this.handleFetch().finally(() => this.pageInited = true);
  }

  handleFilter() {
    this.$router.replace({ query: { ...this.$route.query, ...this.filter } });
  }

  handleReset() {
    this.$router.replace({ query: {} });
  }

  async handleFetch({ page = 1, size = 50 } = {}) {
    let commentType = this.COMMENT_TYPE;
    const { id } = this.$route.params;
    const params = {
      BookClub: {
        commentable_id_eq: id, parent_id_null: true, page, per_page: size
      },
      YouthCamp: {
        page, per_page: size
      }
    }[commentType] || {
      commentable_of_any_type_type_eq: commentType, commentable_id_eq: id, parent_id_null: true, page, per_page: size
    };

    if (id) {
      this.$request.get(`${this.resourceName}/${id}`)
        .then(res => {
          this.post = res;
        });
    }

    const apiPath = {
      BookClub: 'experience_comments',
      YouthCamp: 'youth_camp_experience_comments',
    }[commentType] || 'normal_comments';
    const { data, pagination } = await this.$request.get(apiPath, { params: { ...this.$route.query, ...params } });
    this.comments = data;
    this.pagination = pagination;
  }

  handleChange(index, newVal) {
    this.$set(this.comments, index, newVal);
  }
}

export const route = [
  {
    path: '/commments/:commentType/:id',
    name: 'commments.index',
    component: Comments,
    can: 'normal_comments.read',
    meta: {
      can: 'normal_comments.read',
    }
  },
  {
    path: '/commments/youth_camp_experience_comments',
    name: 'commments_youth_camp_experience_comments.index',
    component: Comments,
    can: 'youth_camp_experience_comments.read',
    props: {
      commentType: 'YouthCamp',
    },
    meta: {
      can: 'youth_camp_experience_comments.read',
    }
  }
]

</script>

<style lang="scss" scoped>
  .page {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(247,248,250,.7);
  }

  .box-filter {
    background: #fff;
    flex-shrink: 0;
    padding: 15px 15px 0;
    border-bottom: 1px solid $border-light;
  }

  .page-content {
    box-sizing: border-box;
    flex: 1;
    overflow: auto;
    padding: 15px;
  }

  .empty {
    font-size: 16px;
    text-align: center;
    margin-top: 40px;
  }

  .box-pagination {
    background: #fff;
    flex-shrink: 0;
    padding: 15px;
    border-top: 1px solid $border-light;
  }
</style>
